/** Presentation only: never turn an incomplete revenue share into an exact 100 %. */
export function formatCoveragePercent(value, locale = "cs-CZ") {
    if (value === null || value === undefined || value === "" || !Number.isFinite(Number(value))) return null;
    const percent = Number(value);
    const format = (digits) => new Intl.NumberFormat(locale, {maximumFractionDigits: digits}).format(percent);
    if (percent < 100 && percent >= 99.95) {
        return percent >= 99.995 ? `< ${new Intl.NumberFormat(locale).format(100)}` : format(2);
    }
    return format(1);
}


export function hasKnownActionableCoverageCount(value) {
    return (typeof value === "number" || typeof value === "string")
        && (typeof value !== "string" || value.trim() !== "")
        && Number.isFinite(Number(value)) && Number(value) >= 0;
}

/** True only when at least one finite coverage metric was actually provided. */
export function hasPurchaseCostCoverageContext(data) {
    const {revenueCoveragePercent, knownLineCount, unknownLineCount, actionableUnknownLineCount} = data ?? {};
    const hasCount = (value) => (typeof value === "number" || typeof value === "string")
        && (typeof value !== "string" || value.trim() !== "")
        && Number.isFinite(Number(value)) && Number(value) >= 0;
    const hasPercent = revenueCoveragePercent !== null && revenueCoveragePercent !== undefined
        && revenueCoveragePercent !== "" && Number.isFinite(Number(revenueCoveragePercent));
    return hasPercent || hasCount(knownLineCount) || hasCount(unknownLineCount) || hasCount(actionableUnknownLineCount);
}

/** Exact raw revenue coverage, never a rounded display value or inferred missing count. */
export function shouldHidePurchaseCostCoverage(coveragePercent, actionableUnknownLineCount) {
    return coveragePercent === 100
        && hasKnownActionableCoverageCount(actionableUnknownLineCount)
        && Number(actionableUnknownLineCount) === 0;
}
